import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/sx/Logo_white.svg")